import React, { useCallback } from 'react';
import _ from 'lodash';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import createMutationRequest from 'utils/createMutationRequest';
import useAPI from 'services/useAPI';
// import useApiCall from 'services/useApiCall';
import { useTranslation } from 'localization/useTranslation';
// import useAlerts from 'utils/hooks/useAlerts';
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal';
import { assetKeys } from './queries';

const DeleteAsset = ({ confirmDeleteItem, onDelete, cancelDelete }) => {
  const T = useTranslation();
  const api = useAPI();
  // const [deletePhysicalId, setDeletePhysicalId] = useState(true);
  // const [alerts, , addErrorAlert] = useAlerts();
  const queryClient = useQueryClient();

  // const [confirmedDelete, isDeleting] = useApiCall({
  //   apiCall: api.core.deleteAsset,
  //   onSuccess: useCallback(() => {
  //     onDelete(confirmDeleteItem);
  //   }, [confirmDeleteItem, onDelete]),
  //   onError: useCallback((error) => {
  //     addErrorAlert(T.common.request.delete.failed);
  //     console.error(error);
  //   }, [T.common.request.delete.failed, addErrorAlert])
  // });

  const deleteAsset = useMutation(createMutationRequest(api.core.deleteAsset), {
    onMutate: (deleteItem) => {
      const oldData = queryClient.getQueryData(assetKeys.assets());
      queryClient.setQueryData(assetKeys.assets(), (oldData) => {
        return _.filter(oldData, (asset) => {
          return asset.id !== confirmDeleteItem.id;
        });
      });
      return { deleteItem, oldData };
    },
    onSuccess: () => {
      onDelete(confirmDeleteItem);
      queryClient.invalidateQueries(assetKeys.assets());
    },
    onError: (error, unusedVariables, context) => {
      // addErrorAlert(T.common.request.delete.failed);
      console.error(error);
      queryClient.setQueryData(assetKeys.assets(), context.oldData);
    }
  });

  const onConfirmedDelete = useCallback((asset) => {
    deleteAsset.mutate(asset.id);
  }, [deleteAsset]);

  return (
    <>
      <ConfirmDeleteModal
        isLoading={deleteAsset.isLoading}
        onConfirm={onConfirmedDelete}
        item={confirmDeleteItem}
        itemName={confirmDeleteItem?.displayName ?? T.common.noname}
        onCancel={cancelDelete}
      >
        { /* <Checkbox id="delete-physicalID"
          label={T.admin.asset.delete.deviceLabel}
          description={T.admin.asset.delete.deviceWarning}
          onChange={checked => setDeletePhysicalId(checked)}
          isChecked={deletePhysicalId}
        /> */ }
      </ConfirmDeleteModal>
    </>
  );
};

export default DeleteAsset;
